import { render, staticRenderFns } from "./FpSimpleTree.vue?vue&type=template&id=dafc577e&lang=pug&"
import script from "./FpSimpleTree.vue?vue&type=script&lang=js&"
export * from "./FpSimpleTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports